export default __webpack_public_path__ + "static/media/ExploreColonizeCreate.d8efd931.png";